var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 92,
    viewBox: "0 0 73 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2527 80.1657L43.3773 51.4804C43.3773 51.4804 43.4155 49.8111 43.3773 47.876C43.339 45.9409 44.2497 43.209 44.2497 42.7536C44.2497 42.2983 43.4529 39.4526 42.0869 36.6068C40.7209 33.761 40.1518 29.8908 40.1518 26.4759C40.1518 23.061 39.8103 21.9226 40.1518 20.1014C40.4933 18.2801 40.4933 19.0195 41.0624 17.2556C41.6316 15.4917 42.5996 15.2066 44.2497 14.4672C45.8998 13.7278 47.8923 11.7917 49.1444 15.662C49.1444 15.662 49.8274 17.4268 50.9657 19.1333C52.104 20.8399 53.1858 22.6621 53.9253 24.1419C54.6647 25.6217 55.803 26.6462 53.9253 28.0121C52.0475 29.3781 48.9732 25.4514 48.5179 24.711C48.0625 23.9707 47.3796 22.5483 46.9242 22.1494C46.4689 21.7505 44.9891 19.9292 44.9891 19.9292C44.9891 19.9292 44.5338 19.3027 44.1923 18.7345",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0664 21.2188C46.0664 21.2188 43.3399 21.4828 42.3154 21.2188",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9258 13.3244V8.77484C46.9258 8.77484 46.9822 5.8717 48.0641 5.13226C49.1459 4.39281 51.3652 3.48217 52.2184 4.67693C53.0717 5.8717 55.0642 10.9376 55.4622 12.4739C55.8601 14.0101 56.259 16.3441 56.6569 17.6536C57.0549 18.9631 57.7388 21.41 60.0718 20.9547C62.4049 20.4994 62.8038 18.9622 62.5761 16.5153C62.3485 14.0684 61.609 11.4503 61.609 11.4503C61.609 11.4503 61.1537 10.1982 61.0399 9.1737C60.926 8.14922 60.641 1.43322 57.9664 1.09173C55.2919 0.750234 53.6409 1.37585 53.2994 2.74181C53.2994 2.74181 53.0717 4.16424 54.2674 9.08719",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5767 10.7664C48.5767 10.7664 49.4308 12.1824 50.1703 13.3244C50.9097 14.4663 51.9916 16.9706 52.7884 19.0195C53.5852 21.0685 54.7235 21.5967 56.0895 21.2187C57.4554 20.8408 57.4327 19.9857 57.0457 18.8192",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3008 4.22446C60.3008 4.22446 60.9264 2.05894 62.0647 2.00157C63.203 1.9442 64.5125 2.00157 64.5125 2.00157C64.5125 2.00157 66.2773 2.51335 66.6179 3.5952C66.9585 4.67705 67.0732 6.27068 67.0732 9.00261C67.0732 11.7345 67.0732 13.2717 67.0732 15.776C67.0732 18.2803 65.4796 18.9068 64.5125 18.9068C63.5454 18.9068 62.7322 18.5097 62.6329 17.3132",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3735 13.6697C49.3735 13.6697 49.6012 13.9538 50.113 13.6697",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9673 19.1336C50.9673 19.1336 51.9681 18.5744 52.5208 18.3413",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0734 13.6697L71.0001 20.2719C71.0001 20.2719 72.5937 22.7197 72.1384 24.1421C71.683 25.5645 69.9756 27.7282 69.2352 29.2071C68.4949 30.686 66.7874 35.0125 65.0809 36.6061C63.3743 38.1997 62.8024 41.2158 62.6321 42.9241C62.4628 44.6316 62.4054 46.5103 62.2916 47.9327C62.1777 49.3551 61.2671 57.2668 61.3809 59.3722C61.4947 61.4776 62.2916 77.8128 62.5757 81",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6328 19.8354C62.6328 19.8354 63.1838 20.8217 65.3848 20.5184",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0336 20.2063C63.0336 20.2063 62.5009 21.2772 64.7775 22.492L66.7964 23.3271",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6758 50.5625L24.9805 71.1875L32.2461 50.5625H39.9414V79H34.0625V71.2266L34.6484 57.8086L26.9727 79H22.9492L15.293 57.8281L15.8789 71.2266V79H10.0195V50.5625H17.6758Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 67.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMhand);
export default __webpack_public_path__ + "static/media/Mhand.2e388ee2a699483d3475370f023b0b31.svg";
export { ForwardRef as ReactComponent };